import React from 'react'

import clsx from 'clsx'

import classes from './Separator.module.scss'

const Separator = ({ className }) => <div className={clsx('Separator', classes.root, className)} />

export default Separator
